/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Share_DownloadedInputs */

const en_us2_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image saved to your downloads.`)
};

const pt_br2_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagem salva nos downloads.`)
};

const es_419_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen guardada en tus descargas.`)
};

const pt_pt2_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagem guardada nas transferências.`)
};

const fr_fr2_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image enregistrée dans tes téléchargements.`)
};

const de_de2_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild in deinen Downloads gespeichert.`)
};

const it_it2_workout_share_share_downloaded = /** @type {(inputs: Workout_Share_Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immagine salvata nei download.`)
};

/**
* | output |
* | --- |
* | "Image saved to your downloads." |
*
* @param {Workout_Share_Share_DownloadedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_share_downloaded = /** @type {((inputs?: Workout_Share_Share_DownloadedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Share_DownloadedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_share_downloaded(inputs)
	if (locale === "es-419") return es_419_workout_share_share_downloaded(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_share_downloaded(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_share_downloaded(inputs)
	if (locale === "de-DE") return de_de2_workout_share_share_downloaded(inputs)
	if (locale === "it-IT") return it_it2_workout_share_share_downloaded(inputs)
	return en_us2_workout_share_share_downloaded(inputs)
});
export { workout_share_share_downloaded as "workout-share.share_downloaded" }